"use client";

import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import { Ingredients } from "../../../Ingredients/Ingredients";
import { FeatureFlags, Product, RuntimeConfig } from "@/types/types";
import { useSkinMatchStatus } from "@/hooks/useSkinMatch/useSkinMatch";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { getEan } from "@/utils/variant/getEan";
import { recordImpressionByParam } from "@JohnLewisPartnership/experiments-utils";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema.ts";
import { useState } from "react";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
import { useMonetateId } from "@/hooks/useMonetateId/useMonetateId.ts";
import { transformExperiences } from "@/utils/monetate/transformExperiences";

type Props = {
  product: Product;
  runtimeConfig: RuntimeConfig;
  open?: boolean;
  experiencesRawObject: Experiences;
  flags: FeatureFlags;
};

export const PRODUCT_INGREDIENTS_ACCORDION_INSTANCE_NAME = "ingredients";

export function ProductIngredientsAccordionUI({
  product,
  runtimeConfig,
  experiencesRawObject,
  flags,
  open,
}: Props) {
  const { variant } = useVariant(product);
  const ean = getEan(variant);
  const skinMatchLookUpBaseUrl = runtimeConfig?.skinMatchLookUpBaseUrl;
  const skinMatchLookUpData = useSkinMatchStatus(ean, skinMatchLookUpBaseUrl);
  const showSkinMatch = !!flags.showSkinMatch.value;
  const [isOpen, setIsOpen] = useState(open);
  const { monetateId } = useMonetateId();
  if (
    skinMatchLookUpData &&
    skinMatchLookUpData.status == "Done" &&
    skinMatchLookUpData.data.skinMatchStatus
  ) {
    recordImpressionByParam(
      runtimeConfig?.monetateEnvironment,
      transformExperiences(experiencesRawObject),
      "pdp-scaffold-showSkinMatch",
      showSkinMatch ? "true" : "false",
      monetateId,
    );
    dispatchMonetateQEvent("wpdp-ingredients-content-found");

    return showSkinMatch ? (
      <ProductAccordionWithMonetateEvents name="Ingredients" open={isOpen}>
        <Accordion
          id="accordion-ingredients"
          data-testid="accordion:ingredients"
          label="Ingredients"
          animated={true}
          instanceName={PRODUCT_INGREDIENTS_ACCORDION_INSTANCE_NAME}
          responsive
          open={open}
          onStateChange={(isOpen: boolean) => {
            setIsOpen(isOpen);
            if (isOpen) {
              dispatchMonetateQEvent("open_ingredients_accordion");
            }
          }}
        >
          <Ingredients
            product={product}
            runtimeConfig={runtimeConfig}
            experiencesRawObject={experiencesRawObject}
          />
        </Accordion>
      </ProductAccordionWithMonetateEvents>
    ) : null;
  } else {
    return null;
  }
}
